import axiosClient from './axiosClient';

const fileApi = {
  get: (params) => {
    const url = '/files/get-files';
    return axiosClient.get(url, { params });
  },
  getByPost: (data, config = {}) => {
    const url = '/files/get-files';
    return axiosClient.post(url, data, config);
  },
  getFileShare: (params) => {
    const url = '/files/share-files';
    return axiosClient.get(url, { params });
  },
  uploadToCourse: (body, config = {}) => {
    const url = '/files';
    return axiosClient.post(url, body, config);
  },
  uploadToCredit: (body) => {
    const url = '/files/credit-file';
    return axiosClient.post(url, body);
  },
  uploadToGloabal: (body, config = {}) => {
    const url = '/files/global-files';
    return axiosClient.post(url, body, config);
  },
  getFileById: (params) => {
    const url = '/files';
    return axiosClient.get(url, { params });
  },
  getDetailById: (id) => {
    const url = `/files/${id}`;
    return axiosClient.get(url);
  },
  edit: (params, data) => {
    const url = '/files';
    return axiosClient.put(url, data, { params });
  },
  editDetail: (id, data) => {
    const url = `/files/${id}`;
    return axiosClient.put(url, data);
  },
  delete: (params) => {
    const url = '/files';
    return axiosClient.delete(url, { params });
  },
  // uploadUserFile: (formData, config = {}) => {
  //   const url = '/users-file';
  //   return axiosClient.post(url, formData, config);
  // },

  uploadUserFile: (formData, config = {}) => {
    const query = config?.unit ? new URLSearchParams(config).toString() : '';
    const url = `/users-file${query ? '?' + query : ''}`;
    return axiosClient.post(url, formData, config);
  },

  getInstructorForCourse: (id) => {
    const url = `/groups/get-instructors/${id}`;
    return axiosClient.get(url);
  },
  getInstructorForIntake: (id) => {
    const url = `/groups/get-intake-instructors/${id}`;
    return axiosClient.get(url);
  },

  getGlobalFileUpdate: () => {
    const url = `/files/global-files`;
    return axiosClient.get(url);
  },
};

export default fileApi;
